import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

    private dataSource = new BehaviorSubject(null);
    currentData = this.dataSource.asObservable();

    constructor() { }

    passData(data: any) {
        this.dataSource.next(data)
    }

    public model: any;

    public getModel() {
        return this.model;
    }
    public setModel(model: any): void {
        this.model = model;
    }
    public resetModel() {
        this.model = null;
        return this.model;
    }
}
